module.exports = __webpack_public_path__ + "static/media/mm.3ff6a469.png";